// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"791":"1acdcb3b","844":"8e7dac67"}[chunkId] + ".chunk.css";
};